import gql from "graphql-tag";

export const GET_PATIENT_FUTURE_APPOINTMENT_COUNT = gql`
  query GetPatientFutureAppointmentCount($patientId: String) {
    getPatientFutureAppointmentCount(patientId: $patientId) {
      consultsCount
      activeAndInProgressConsultsCount
      upcomingConsultsCount
      followUpConsultsCount
      todaysConsultsCount
      activeConsultsCount
    }
  }
`;

export const ADD_HOSPITALIZATION_RECORD = gql`
  mutation addPatientHospitalizationRecord(
    $AddHospitalizationRecordInput: AddHospitalizationRecordInput
  ) {
    addPatientHospitalizationRecord(
      addHospitalizationRecordInput: $AddHospitalizationRecordInput
    ) {
      status
    }
  }
`;

export const ADD_LAB_RESULT_RECORD = gql`
  mutation addPatientLabTestRecord(
    $AddLabTestRecordInput: AddLabTestRecordInput
  ) {
    addPatientLabTestRecord(addLabTestRecordInput: $AddLabTestRecordInput) {
      status
    }
  }
`;

export const ADD_PATIENT_MEDICAL_BILL_RECORD = gql`
  mutation addPatientMedicalBillRecord(
    $addPatientMedicalBillRecordInput: AddPatientMedicalBillRecordInput
  ) {
    addPatientMedicalBillRecord(
      addPatientMedicalBillRecordInput: $addPatientMedicalBillRecordInput
    ) {
      status
    }
  }
`;

export const ADD_PATIENT_VACCINATION_RECORD = gql`
  mutation addPatientImmunizationRecord(
    $addImmunizationRecordInput: AddImmunizationRecordInput
  ) {
    addPatientImmunizationRecord(
      addImmunizationRecordInput: $addImmunizationRecordInput
    ) {
      status
    }
  }
`;

export const ADD_PRESCRIPTION_RECORD = gql`
  mutation addPatientPrescriptionRecord(
    $AddPrescriptionRecordInput: AddPrescriptionRecordInput
  ) {
    addPatientPrescriptionRecord(
      addPrescriptionRecordInput: $AddPrescriptionRecordInput
    ) {
      status
    }
  }
`;

export const DELETE_MULTIPLE_HEALTH_RECORD_FILES = gql`
  mutation deleteMultipleHealthRecordFiles(
    $deleteMultipleHealthRecordFilesInput: DeleteMultipleHealthRecordFilesInput
  ) {
    deleteMultipleHealthRecordFiles(
      deleteMultipleHealthRecordFilesInput: $deleteMultipleHealthRecordFilesInput
    ) {
      status
    }
  }
`;

export const GET_ALL_CLINICAL_DOCUMENTS = gql`
  query getClinicalDocuments($uhid: String!, $mobileNumber: String!) {
    getClinicalDocuments(uhid: $uhid, mobileNumber: $mobileNumber) {
      response {
        id
        documentName
        uhid
        mobileNumber
        uploadedVia
        documentStatus
        fileTypeId
        fileType
        createddate
        lastmodifieddate
        authToken
        source
        parentFolder
        fileInfoList {
          id
          fileStatus
          locationtype
          file_location
          fileName
          mimeType
          content
          byteContent
          file_Url
        }
      }
    }
  }
`;

export const GET_INDIVIDUAL_TEST_RESULT_PDF = gql`
  query getIndividualTestResultPdf(
    $patientId: ID!
    $recordId: String!
    $sequence: String!
  ) {
    getIndividualTestResultPdf(
      patientId: $patientId
      recordId: $recordId
      sequence: $sequence
    ) {
      url
    }
  }
`;

export const GET_INFORMATIVECONTENT_DATA = gql`
  query getInformativeContent($uhid: String!, $params: [TestNameInputs]) {
    getInformativeContent(uhid: $uhid, params: $params) {
      errorMsg
      response {
        testName
        parameterName
        loincCode
        contentCode
      }
    }
  }
`;

export const GET_LAB_RESULT_MERGE_PDF = gql`
  mutation mergePDFS($fileUrls: [String]!, $uhid: String!) {
    mergePDFS(fileUrls: $fileUrls, uhid: $uhid) {
      mergepdfUrl
    }
  }
`;

export const GET_LAB_RESULT_PDF = gql`
  query getLabResultpdf($patientId: ID!, $recordId: String!) {
    getLabResultpdf(patientId: $patientId, recordId: $recordId) {
      url
    }
  }
`;

export const GET_PATIENT_BY_UHID = gql`
  query getPatientByUhid($uhid: String) {
    getPatientByUhid(uhid: $uhid) {
      patient {
        firstName
      }
    }
  }
`;

export const GET_VISUALIZATION_DATA = gql`
  query getVisualizationData(
    $uhid: String!
    $serviceName: String!
    $parameterName: String!
    $loincCode: String
  ) {
    getVisualizationData(
      uhid: $uhid
      serviceName: $serviceName
      parameterName: $parameterName
      loincCode: $loincCode
    ) {
      errorCode
      errorMsg
      response {
        parameterName
        result
        unit
        range
        resultDate
      }
    }
  }
`;

export const PHR_COVERT_TO_ZIP = gql`
  mutation convertToZip($fileUrls: [String]!, $uhid: String!) {
    convertToZip(fileUrls: $fileUrls, uhid: $uhid) {
      zipUrl
    }
  }
`;

export const SAVE_CLINICAL_DOCUMENTS = gql`
  mutation saveClinicalDocuments(
    $addClinicalDocumentInput: AddClinicalDocumentInput
  ) {
    saveClinicalDocuments(addClinicalDocumentInput: $addClinicalDocumentInput) {
      status
      id
    }
  }
`;

export const GET_CIRCLE_SAVINGS_OF_USER = gql`
  query GetCircleSavingsOfUserByMobile($mobile_number: String!) {
    GetCircleSavingsOfUserByMobile(mobile_number: $mobile_number) {
      success
      response
    }
  }
`;

export const ADD_DIABETIC_QUESTIONNAIRE = gql`
  mutation addDiabeticQuestionnaire(
    $addDiabeticQuestionnaireInput: AddDiabeticQuestionnaireInput
  ) {
    addDiabeticQuestionnaire(
      addDiabeticQuestionnaireInput: $addDiabeticQuestionnaireInput
    ) {
      success
    }
  }
`;

export const SEARCH_DIAGNOSTICS_BY_CITY_ID = gql`
  query searchDiagnosticsByCityID($cityID: Int!, $searchText: String!) {
    searchDiagnosticsByCityID(cityID: $cityID, searchText: $searchText) {
      diagnostics {
        canonicalTag
        id
        itemId
        itemName
        itemType
        rate
        itemType
        gender
        itemRemarks
        city
        state
        collectionType
        fromAgeInDays
        toAgeInDays
        testPreparationData
        inclusions
        packageCalculatedMrp
        diagnosticPricing {
          mrp
          price
          groupPlan
          startDate
          endDate
          status
          couponCode
        }
      }
    }
  }
`;

export const GET_PHR_USER_NOTIFY_EVENTS = gql`
  query getUserNotifyEvents($patientId: ID!) {
    getUserNotifyEvents(patientId: $patientId) {
      phr {
        newRecordsCount {
          LabTest
          Allergy
          Bill
          HealthCheck
          Hospitalization
          Insurance
          MedicalCondition
          Medication
          Prescription
          Restriction
        }
      }
    }
  }
`;

export const ADD_PROFILE = gql`
  mutation AddNewProfile($PatientProfileInput: PatientProfileInput!) {
    addNewProfile(patientProfileInput: $PatientProfileInput) {
      patient {
        id
        uhid
        mobileNumber
        firstName
        lastName
        emailAddress
        gender
        dateOfBirth
      }
    }
  }
`;

export const DELETE_PROFILE = gql`
  mutation DeleteProfile($patientId: String) {
    deleteProfile(patientId: $patientId) {
      status
    }
  }
`;

export const DELETE_PATIENT_MEDICAL_RECORD = gql`
  mutation deletePatientPrismMedicalRecord(
    $deletePatientPrismMedicalRecordInput: DeletePatientPrismMedicalRecordInput
  ) {
    deletePatientPrismMedicalRecord(
      deletePatientPrismMedicalRecordInput: $deletePatientPrismMedicalRecordInput
    ) {
      status
    }
  }
`;

export const GET_HEALTH_RECORDS = gql`
  query getPatientPrismMedicalRecords_V3(
    $patientId: ID!
    $records: [MedicalRecordType]
    $recordId: String
    $source: String
  ) {
    getPatientPrismMedicalRecords_V3(
      patientId: $patientId
      records: $records
      recordId: $recordId
      source: $source
    ) {
      labResults {
        errorCode
        errorMsg
        errorType
        response {
          identifier
          authToken
          id
          labTestName
          labTestSource
          packageId
          packageName
          # labTestDate
          date
          labTestRefferedBy
          siteDisplayName
          tag
          consultId
          additionalNotes
          observation
          labTestResults {
            parameterName
            unit
            result
            range
            outOfRange
            resultDate
          }
          fileUrl
          testResultFiles {
            id
            fileName
            mimeType
            content
            byteContent
            downloadUrl
            file_Url
            index
          }
        }
      }
      prescriptions {
        response {
          id
          prescriptionName
          date
          # dateOfPrescription
          # startDate
          # endDate
          prescribedBy
          notes
          prescriptionSource
          source
          siteDisplayName
          fileUrl
          prescriptionFiles {
            id
            fileName
            mimeType
            content
            byteContent
            file_Url
            index
          }
        }
        errorCode
        errorMsg
        errorType
      }
      healthChecks {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          fileUrl
          date
          healthCheckName
          healthCheckDate
          healthCheckSummary
          healthCheckFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          source
          siteDisplayName
          healthCheckType
          followupDate
        }
      }
      hospitalizations {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          fileUrl
          date
          hospitalizationDate
          dateOfHospitalization
          hospitalName
          doctorName
          reasonForAdmission
          diagnosisNotes
          dateOfDischarge
          dischargeSummary
          doctorInstruction
          dateOfNextVisit
          hospitalizationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          siteDisplayName
          source
        }
      }
      medicalConditions {
        errorCode
        errorMsg
        errorType
        response {
          id
          medicalConditionName
          doctorTreated
          startDate
          source
          siteDisplayName
          endDate
          notes
          illnessType
          fileUrl
          startDateTime
          endDateTime
          medicationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }
      medicalBills {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          bill_no
          hospitalName
          billDate
          source
          siteDisplayName
          notes
          fileUrl
          billDateTime
          billFiles {
            id
            fileName
            mimeType
            byteContent
            dateCreated
            content
            file_Url
            index
          }
        }
      }
      medicalInsurances {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          insuranceCompany
          policyNumber
          startDate
          endDate
          startDateTime
          endDateTime
          source
          siteDisplayName
          fileUrl
          sumInsured
          insuranceFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          notes
        }
      }
      medications {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          medicineName
          medicalCondition
          doctorName
          startDate
          endDate
          startDateTime
          endDateTime
          morning
          noon
          evening
          notes
          source
          siteDisplayName
        }
      }
      healthRestrictions {
        errorCode
        errorMsg
        errorType
        response {
          id
          startDate
          endDate
          startDateTime
          endDateTime
          restrictionName
          source
          siteDisplayName
          suggestedByDoctor
          nature
          notes
        }
      }
      allergies {
        errorCode
        errorMsg
        errorType
        response {
          id
          startDate
          endDate
          fileUrl
          startDateTime
          endDateTime
          allergyName
          severity
          reactionToAllergy
          doctorTreated
          notes
          source
          siteDisplayName
          attachmentList {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }
      familyHistory {
        errorCode
        errorMsg
        errorType
        response {
          id
          diseaseName
          authToken
          source
          siteDisplayName
          fileUrl
          familyMember
          notes
          recordDateTime
          age
          familyHistoryFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }
    }
  }
`;

export const UPDATE_PATIENT_MEDICAL_PARAMETERS = gql`
  mutation updatePatientMedicalParameters(
    $patientMedicalParameters: PatientMedicalParameters
  ) {
    updatePatientMedicalParameters(
      patientMedicalParameters: $patientMedicalParameters
    ) {
      patient {
        id
        patientMedicalHistory {
          bloodGroup
          height
          weight
        }
      }
    }
  }
`;

export const GET_PRISM_AUTH_TOKEN = gql`
  query getPrismAuthToken($uhid: String!) {
    getPrismAuthToken(uhid: $uhid) {
      errorCode
      errorMsg
      errorType
      response
    }
  }
`;

export const GET_MEDICAL_RECORDS = gql`
  query getPatientPrismMedicalRecords_V3(
    $patientId: ID!
    $records: [MedicalRecordType]
    $recordId: String
    $source: String
  ) {
    getPatientPrismMedicalRecords_V3(
      patientId: $patientId
      records: $records
      recordId: $recordId
      source: $source
    ) {
      immunizations {
        errorCode
        errorMsg
        errorType
        response {
          id
          immunizationName
          dateAdministered
          followUpDate
          registrationId
          dateOfImmunization
          dueDate
          fileUrl
          doctorName
          manufacturer
          batchno
          vaccineName
          potency
          hospitalName
          vaccine_location
          notes
          source
          reactions {
            type
            from
            to
          }
          immunizationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
        }
      }

      labResults {
        errorCode
        errorMsg
        errorType
        response {
          identifier
          authToken
          id
          labTestName
          labTestSource
          packageId
          packageName
          # labTestDate
          date

          labTestRefferedBy
          siteDisplayName
          tag
          consultId
          additionalNotes
          observation
          labTestResults {
            loincCode
            parameterName
            unit
            result
            range
            outOfRange
            resultDate
          }
          fileUrl
          billNo
          testSequence
          packageName
          testResultFiles {
            id
            fileName
            mimeType
            content
            byteContent
            downloadUrl
            file_Url
            index
          }
        }
      }

      prescriptions {
        response {
          id
          documentId
          prescriptionName
          date
          # dateOfPrescription
          # startDate
          # endDate
          prescribedBy
          notes
          prescriptionSource
          source
          siteDisplayName
          fileUrl
          prescriptionFiles {
            id
            fileName
            mimeType
            content
            byteContent
            file_Url
            index
          }
        }
        errorCode
        errorMsg
        errorType
      }

      healthChecks {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          documentId
          fileUrl
          date
          healthCheckName
          healthCheckDate
          healthCheckSummary
          healthCheckFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          source
          siteDisplayName
          healthCheckType
          followupDate
        }
      }
      hospitalizations {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          documentId
          fileUrl
          date
          hospitalizationDate
          dateOfHospitalization
          hospitalName
          doctorName
          reasonForAdmission
          diagnosisNotes
          dateOfDischarge
          dischargeSummary
          doctorInstruction
          dateOfNextVisit
          hospitalizationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          siteDisplayName
          source
        }
      }

      medicalConditions {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          medicalConditionName
          doctorTreated
          startDate
          source
          siteDisplayName
          endDate
          notes
          illnessType
          fileUrl
          startDateTime
          endDateTime
          medicationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }
      medicalBills {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          bill_no
          hospitalName
          billDate
          source
          siteDisplayName
          notes
          fileUrl
          billDateTime
          billFiles {
            id
            fileName
            mimeType
            byteContent
            dateCreated
            content
            file_Url
            index
          }
        }
      }
      medicalInsurances {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          insuranceCompany
          policyNumber
          startDate
          endDate
          startDateTime
          endDateTime
          source
          siteDisplayName
          fileUrl
          sumInsured
          insuranceFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
          notes
        }
      }
      medications {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          medicineName
          medicalCondition
          doctorName
          startDate
          endDate
          startDateTime
          endDateTime
          morning
          noon
          evening
          notes
          source
          siteDisplayName
        }
      }
      healthRestrictions {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          startDate
          endDate
          startDateTime
          endDateTime
          restrictionName
          source
          siteDisplayName
          suggestedByDoctor
          nature
          notes
        }
      }
      allergies {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          startDate
          endDate
          fileUrl
          startDateTime
          endDateTime
          allergyName
          severity
          reactionToAllergy
          doctorTreated
          notes
          source
          siteDisplayName
          attachmentList {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }

      familyHistory {
        errorCode
        errorMsg
        errorType
        response {
          id
          documentId
          diseaseName
          authToken
          source
          siteDisplayName
          fileUrl
          familyMember
          notes
          recordDateTime
          age
          familyHistoryFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
            file_Url
            index
          }
        }
      }
    }
  }
`;

export const ADD_FAMILY_HISTORY_RECORD = gql`
  mutation savePatientFamilyHistoryToPRISM(
    $familyHistoryParameters: FamilyHistoryParameters
  ) {
    savePatientFamilyHistoryToPRISM(
      familyHistoryParameters: $familyHistoryParameters
    ) {
      status
    }
  }
`;

export const ADD_PATIENT_ALLERGY_RECORD = gql`
  mutation addPatientAllergyRecord(
    $addAllergyRecordInput: AddAllergyRecordInput
  ) {
    addPatientAllergyRecord(addAllergyRecordInput: $addAllergyRecordInput) {
      status
    }
  }
`;

export const ADD_PATIENT_HEALTH_RESTRICTION_RECORD = gql`
  mutation addPatientHealthRestrictionRecord(
    $addPatientHealthRestrictionRecordInput: AddPatientHealthRestrictionRecordInput
  ) {
    addPatientHealthRestrictionRecord(
      addPatientHealthRestrictionRecordInput: $addPatientHealthRestrictionRecordInput
    ) {
      status
    }
  }
`;

export const ADD_PATIENT_MEDICATION_RECORD = gql`
  mutation addPatientMedicationRecord(
    $addPatientMedicationRecordInput: AddPatientMedicationRecordInput
  ) {
    addPatientMedicationRecord(
      addPatientMedicationRecordInput: $addPatientMedicationRecordInput
    ) {
      status
    }
  }
`;

export const ADD_PATIENT_MEDICAL_CONDITION_RECORD = gql`
  mutation addPatientMedicalConditionRecord(
    $addMedicalConditionRecordInput: AddMedicalConditionRecordInput
  ) {
    addPatientMedicalConditionRecord(
      addMedicalConditionRecordInput: $addMedicalConditionRecordInput
    ) {
      status
    }
  }
`;

export const ADD_PATIENT_MEDICAL_INSURANCE_RECORD = gql`
  mutation addPatientMedicalInsuranceRecord(
    $addPatientMedicalInsuranceRecordInput: AddPatientMedicalInsuranceRecordInput
  ) {
    addPatientMedicalInsuranceRecord(
      addPatientMedicalInsuranceRecordInput: $addPatientMedicalInsuranceRecordInput
    ) {
      status
    }
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateUserSubscription(
    $userSubscription: CreateUserSubscriptionInput!
  ) {
    CreateUserSubscription(UserSubscription: $userSubscription) {
      code
      success
      message
      response {
        mobile_number
        status
        start_date
        end_date
        _id
        group_plan {
          name
          plan_id
          plan_summary
        }
      }
    }
  }
`;

export const EDIT_PROFILE = gql`
  mutation EditProfile($editProfileInput: EditProfileInput!) {
    editProfile(editProfileInput: $editProfileInput) {
      patient {
        id
        photoUrl
        firstName
        lastName
        relation
        gender
        dateOfBirth
        emailAddress
      }
    }
  }
`;

export const GET_ALL_BANNERS_OF_USER = gql`
  query GetAllGroupBannersOfUser(
    $mobile_number: String
    $banner_context: String!
    $user_state: UserState
  ) {
    GetAllGroupBannersOfUser(
      mobile_number: $mobile_number
      banner_context: $banner_context
      user_state: $user_state
    ) {
      message
      response {
        banner
        banner_context
        banner_template_info
        banner_visibility_mode
        meta
        cta_action
        is_active
        priority
        banner_display_type
      }
    }
  }
`;

export const GET_ALL_USER_SUBSCRIPTIONS_WITH_BENEFITS = gql`
  query GetAllUserSubscriptionsWithPlanBenefitsV2($mobile_number: String!) {
    GetAllUserSubscriptionsWithPlanBenefitsV2(mobile_number: $mobile_number) {
      code
      message
      success
      response
    }
  }
`;

export const GET_CIRCLE_RENEWAL_AGGREGATED = gql`
  query circleAggregated(
    $mobile_number: String!
    $banner_context: String!
    $user_state: UserState
    $patientId: String
    $banner_display_type: [BannerDisplayType!]
  ) {
    GetCircleSavingsOfUserByMobile(mobile_number: $mobile_number) {
      success
      response
    }
    GetAllGroupBannersOfUser(
      mobile_number: $mobile_number
      banner_context: $banner_context
      user_state: $user_state
      banner_display_type: $banner_display_type
    ) {
      message
      response {
        banner
        banner_context
        banner_template_info
        banner_visibility_mode
        meta
        cta_action
        is_active
        priority
        banner_display_type
      }
    }
    getOneApolloUser(patientId: $patientId) {
      availableHC
      name
      earnedHC
      tier
      burnedCredits
      blockedCredits
    }
  }
`;

export const GET_CURRENT_PATIENTS = gql`
  query GetCurrentPatients {
    getCurrentPatients {
      patients {
        id
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        photoUrl
        createdDate
        externalAuthId
      }
    }
  }
`;

export const GET_LATEST_MEDICINE_ORDER = gql`
  query getLatestMedicineOrder($patientUhid: String!) {
    getLatestMedicineOrder(patientUhid: $patientUhid) {
      medicineOrderDetails {
        id
        createdDate
        orderAutoId
        billNumber
        shopAddress
        prescriptionImageUrl
        medicineOrderLineItems {
          medicineSKU
          medicineName
          price
          mrp
          quantity
        }
        currentStatus
        medicineOrderShipments {
          medicineOrderInvoice {
            itemDetails
          }
        }
      }
    }
  }
`;

export const GET_MEDICAL_PRISM_RECORD = gql`
  query getPatientPrismMedicalRecords($patientId: ID!) {
    getPatientPrismMedicalRecords(patientId: $patientId) {
      labTests {
        id
        labTestName
        labTestSource
        labTestDate
        labTestReferredBy
        additionalNotes
        testResultPrismFileIds
        observation
        labTestResultParameters {
          parameterName
          unit
          result
          range
          setOutOfRange
          setResultDate
          setUnit
          setParameterName
          setRange
          setResult
        }
        departmentName
        signingDocName
      }
      healthChecks {
        id
        healthCheckName
        healthCheckDate
        healthCheckPrismFileIds
        healthCheckSummary
        source
        appointmentDate
        followupDate
      }
      hospitalizations {
        id
        diagnosisNotes
        dateOfDischarge
        dateOfHospitalization
        dateOfNextVisit
        hospitalizationPrismFileIds
        source
      }
      labResults {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          id
          labTestName
          labTestSource
          packageId
          packageName
          # labTestDate
          date
          labTestRefferedBy
          siteDisplayName
          tag
          consultId
          additionalNotes
          observation
          labTestResults {
            parameterName
            unit
            result
            range
            outOfRange
            # resultDate
          }
          fileUrl
          testResultFiles {
            id
            fileName
            mimeType
            content
            byteContent
          }
        }
        errorCode
        errorMsg
        errorType
      }
      prescriptions {
        response {
          id
          prescriptionName
          date
          # dateOfPrescription
          # startDate
          # endDate
          prescribedBy
          notes
          prescriptionSource
          source
          fileUrl
          prescriptionFiles {
            id
            fileName
            mimeType
            content
            byteContent
          }
        }
        errorCode
        errorMsg
        errorType
      }
      healthChecksNew {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          fileUrl
          date
          healthCheckName
          healthCheckDate
          healthCheckSummary
          healthCheckFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
          source
          healthCheckType
          followupDate
        }
      }
      hospitalizationsNew {
        errorCode
        errorMsg
        errorType
        response {
          authToken
          userId
          id
          fileUrl
          date
          hospitalizationDate
          dateOfHospitalization
          hospitalName
          doctorName
          reasonForAdmission
          diagnosisNotes
          dateOfDischarge
          dischargeSummary
          doctorInstruction
          dateOfNextVisit
          hospitalizationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
          source
        }
      }
      medicalConditions {
        errorCode
        errorMsg
        errorType
        response {
          id
          medicalConditionName
          doctorTreated
          startDate
          source
          endDate
          notes
          illnessType
          fileUrl
          startDateTime
          endDateTime
          medicationFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
        }
      }
      medicalBills {
        errorCode
        errorMsg
        errorType
        response {
          id
          bill_no
          hospitalName
          billDate
          source
          notes
          fileUrl
          billDateTime
          billFiles {
            id
            fileName
            mimeType
            byteContent
            dateCreated
          }
        }
      }
      medicalInsurances {
        errorCode
        errorMsg
        errorType
        response {
          id
          insuranceCompany
          policyNumber
          startDate
          endDate
          startDateTime
          endDateTime
          source
          fileUrl
          sumInsured
          insuranceFiles {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
          notes
        }
      }
      medications {
        errorCode
        errorMsg
        errorType
        response {
          id
          medicineName
          medicalCondition
          doctorName
          startDate
          endDate
          startDateTime
          endDateTime
          morning
          noon
          evening
          notes
          source
        }
      }
      healthRestrictions {
        errorCode
        errorMsg
        errorType
        response {
          id
          startDate
          endDate
          startDateTime
          endDateTime
          restrictionName
          source
          suggestedByDoctor
          nature
          notes
        }
      }
      allergies {
        errorCode
        errorMsg
        errorType
        response {
          id
          startDate
          endDate
          fileUrl
          startDateTime
          endDateTime
          allergyName
          severity
          reactionToAllergy
          doctorTreated
          notes
          source
          attachmentList {
            id
            fileName
            mimeType
            content
            byteContent
            dateCreated
          }
        }
      }
    }
  }
`;

export const GET_PAST_CONSULTS_PRESCRIPTIONS = gql`
  query getPatientPastConsultsAndPrescriptions(
    $consultsAndOrdersInput: PatientConsultsAndOrdersInput
  ) {
    getPatientPastConsultsAndPrescriptions(
      consultsAndOrdersInput: $consultsAndOrdersInput
    ) {
      consults {
        id
        patientId
        doctorId
        appointmentDateTime
        appointmentType
        appointmentState
        hospitalId
        isFollowUp
        followUpParentId
        followUpTo
        displayId
        bookingDate
        caseSheet {
          notes
          blobName
          consultType
          diagnosis {
            name
          }
          diagnosticPrescription {
            itemname
          }
          doctorId
          doctorType
          followUp
          followUpAfterInDays
          followUpDate
          followUpConsultType
          id
          medicinePrescription {
            medicineConsumptionDurationInDays
            medicineDosage
            id
            medicineCustomDetails
            medicineConsumptionDurationUnit
            medicineFormTypes
            medicineFrequency
            medicineInstructions
            medicineName
            medicineTimings
            medicineToBeTaken
            medicineUnit
            routeOfAdministration
          }
          symptoms {
            symptom
            since
            howOften
            severity
            details
          }
          otherInstructions {
            instruction
          }
        }
        displayId
        status
        doctorInfo {
          doctorHospital {
            facility {
              id
              name
            }
          }
          id
          salutation
          firstName
          fullName
          lastName
          displayName
          experience
          city
          onlineConsultationFees
          physicalConsultationFees
          photoUrl
          qualification
          specialty {
            name
            image
          }
        }
      }
      medicineOrders {
        id
        orderDateTime
        quoteDateTime
        deliveryType
        currentStatus
        orderType
        estimatedAmount
        prescriptionImageUrl
        shopId
        prismPrescriptionFileId
        medicineOrderLineItems {
          medicineSKU
          medicineName
          price
          quantity
          mrp
          id
        }
      }
    }
  }
`;

export const GET_PATIENT_BY_MOBILE_NUMBER = gql`
  query GetPatientByMobileNumber($mobileNumber: String) {
    getPatientByMobileNumber(mobileNumber: $mobileNumber) {
      patients {
        id
        externalAuthId
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        photoUrl
        referralCode
        partnerId
        isConsulted
        createdDate
        primaryUhid
        patientMedicalHistory {
          height
          weight
          bp
          dietAllergies
          bloodGroup
        }
      }
    }
  }
`;

export const GET_PLAN_DETAILS_BY_ID = gql`
  query GetPlanDetailsByPlanId($plan_id: String!) {
    GetPlanDetailsByPlanId(plan_id: $plan_id) {
      message
      response {
        name
        plan_summary
        meta {
          landing_page_meta_data
        }
        group_sub_plans {
          price
          plan_id
        }
        group {
          name
        }
        meta {
          landing_page_meta_data
        }
        group_sub_plans {
          price
          plan_id
        }
        benefits {
          description
          header_content
          icon
        }
      }
    }
  }
`;

export const GET_RECOMMENDED_PRODUCTS_LIST = gql`
  query getRecommendedProductsList($patientUhid: String!) {
    getRecommendedProductsList(patientUhid: $patientUhid) {
      recommendedProducts {
        productSku
        productName
        productImage
        productPrice
        productSpecialPrice
        isPrescriptionNeeded
        categoryName
        status
        mou
        imageBaseUrl
        id
        is_in_stock
        small_image
        thumbnail
        type_id
        quantity
        isShippable
        MaxOrderQty
        urlKey
      }
    }
  }
`;

export const GET_SUBSCRIPTIONS_OF_USER_BY_STATUS = gql`
  query getSubscriptionsOfUserByStatus(
    $mobile_number: String!
    $status: [String!]!
  ) {
    GetSubscriptionsOfUserByStatus(
      mobile_number: $mobile_number
      status: $status
    ) {
      code
      message
      success
      response
    }
  }
`;

export const IDENTIFY_HDFC_CUSTOMER = gql`
  query identifyHdfcCustomer($mobile_number: String!, $DOB: Date!) {
    identifyHdfcCustomer(mobileNumber: $mobile_number, DOB: $DOB) {
      status
      token
    }
  }
`;

export const INITIATE_CALL_FOR_PARTNER = gql`
  query initiateCallForPartner(
    $mobileNumber: String!
    $benefitId: String!
    $userSubscriptionId: String
  ) {
    initiateCallForPartner(
      mobileNumber: $mobileNumber
      benefitId: $benefitId
      userSubscriptionId: $userSubscriptionId
    ) {
      success
    }
  }
`;

export const INITIATE_DOC_ON_CALL = gql`
  query initiateDocOnCall($mobileNumber: String, $callType: docOnCallType) {
    initiateDocOnCall(mobileNumber: $mobileNumber, callType: $callType) {
      success
    }
  }
`;

export const UPDATE_PATIENT = gql`
  mutation UpdatePatient($patientInput: UpdatePatientInput!) {
    updatePatient(patientInput: $patientInput) {
      patient {
        id
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        partnerId
      }
    }
  }
`;

export const VALIDATE_HDFC_OTP = gql`
  query validateHdfcOTP($otp: String!, $token: String!, $dateOfBirth: Date!) {
    validateHdfcOTP(otp: $otp, token: $token, dateOfBirth: $dateOfBirth) {
      status
      defaultPlan
    }
  }
`;

export const PRO_HEALTH_BOOKING = gql`
  mutation bookProhealthAppointment($appointmentInputs: AppointmentInputs) {
    bookProhealthAppointment(appointmentInputs: $appointmentInputs) {
      displayId
      status
    }
  }
`;

export const GET_PRO_HEALTH_ORDER_DATA = gql`
  query getAllProhealthOrdersByOrderIdOrDisplayId($displayId: ID) {
    getAllProhealthOrdersByOrderIdOrDisplayId(displayId: $displayId) {
      appointments {
        appointmentStartDateTimeUTC
        appointmentEndDateTimeUTC
        status
        displayId
        price
        bookingSource
        packageCategoryId
        patientObj {
          firstName
          lastName
          emailAddress
          dateOfBirth
          mobileNumber
          uhid
          gender
        }
        prohealthPackage {
          packageName
          id
        }
        prohealthHospital {
          unitName
          unitType
          prohealthCity {
            cityName
          }
        }
      }
    }
  }
`;

export const VERIFY_EXTERNAL_AUTH_TOKEN = gql`
  query verifyExternalAuthToken(
    $verifyExternalAuthTokenInput: VerifyExternalAuthTokenInput
  ) {
    verifyExternalAuthToken(
      verifyExternalAuthTokenInput: $verifyExternalAuthTokenInput
    ) {
      status
      reason
      authToken
      isBlocked
      incorrectAttempts
      mobileNumber
      patientId
    }
  }
`;

export const UPDATE_PATIENT_EXTERNAL_AUTH_ID = gql`
  mutation updatePatientExternalAuthId(
    $patientId: String!
    $externalAuthToken: String!
  ) {
    updatePatientExternalAuthId(
      patientId: $patientId
      externalAuthToken: $externalAuthToken
    ) {
      patient {
        id
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        externalAuthId
        dateOfBirth
        emailAddress
        partnerId
      }
    }
  }
`;

export const GET_SITEMAP_DOCTOR_URLS_LIST = gql`
  query doctorUrlsList($pageSize: Int!, $pageNumber: Int!) {
    doctorUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      doctorUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_CITY_SPECIALITY_URLS_LIST = gql`
  query citySpecialityUrlsList($pageSize: Int!, $pageNumber: Int!) {
    citySpecialityUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      citySpecialityUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_CITY_DOCTOR_URLS_LIST = gql`
  query cityDoctorUrlsList($pageSize: Int!, $pageNumber: Int!) {
    cityDoctorUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      cityDoctorUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_LOCALITY_SPECIALITY_URLS_LIST = gql`
  query localitySpecialityUrlsList($pageSize: Int!, $pageNumber: Int!) {
    localitySpecialityUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      localitySpecialityUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_LOCALITY_DOCTOR_URLS_LIST = gql`
  query localityDoctorUrlsList($pageSize: Int!, $pageNumber: Int!) {
    localityDoctorUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      localityDoctorUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_SPECIALITY_NEARME_URLS_LIST = gql`
  query specialityNearMeUrlsList($pageSize: Int!, $pageNumber: Int!) {
    specialityNearMeUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      specialityNearMeUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_SPECIALITY_URLS_LIST = gql`
  query specialityUrlsList($pageSize: Int!, $pageNumber: Int!) {
    specialityUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      specialityUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_ARTICLE_URLS_LIST = gql`
  query articleUrlsList($pageSize: Int!, $pageNumber: Int!) {
    articleUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      articleUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_STATIC_PAGE_URLS_LIST = gql`
  query staticPageUrlsList($pageSize: Int!, $pageNumber: Int!) {
    staticPageUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      staticPageUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_LAB_TEST_DETAILS_URLS_LIST = gql`
  query labTestsDetailsUrlsList($pageSize: Int!, $pageNumber: Int!) {
    labTestsDetailsUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      labTestsDetailsUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_LAB_TEST_CATEGORIES_URLS_LIST = gql`
  query labTestCategoryUrlsList($pageSize: Int!, $pageNumber: Int!) {
    labTestCategoryUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      urlsCount
      labTestsCategoryUrls {
        url
        urlName
      }
    }
  }
`;

export const GET_SITEMAP_HELATH_QUERY_CATEGORIES_URLS_LIST = gql`
  query healthQueryUrlsList($pageSize: Int!, $pageNumber: Int!) {
    healthQueryUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      healthQueryUrls {
        url
        urlName
      }
      urlsCount
    }
  }
`;

export const GET_SITEMAP_DISEASES_AND_CONDITIONS_URLS_LIST = gql`
  query diseaseAndConditionsUrlsList($pageSize: Int!, $pageNumber: Int!) {
    diseaseAndConditionsUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      diseaseAndConditionsUrls {
        urlName
        url
      }
    }
  }
`;

export const UPDATE_WHATSAPP_STATUS = gql`
  mutation UpdateWhatsAppStatus(
    $whatsAppMedicine: Boolean
    $whatsAppConsult: Boolean
    $patientId: String!
  ) {
    updateWhatsAppStatus(
      whatsAppMedicine: $whatsAppMedicine
      whatsAppConsult: $whatsAppConsult
      patientId: $patientId
    ) {
      status
    }
  }
`;

export const BOOK_PACKAGE_CONSULT = gql`
  mutation bookFreeAppointmentForPharmacy(
    $patientId: String!
    $subscriptionDetailsInput: SubscriptionDetailsInput
  ) {
    bookFreeAppointmentForPharmacy(
      patientId: $patientId
      subscriptionOrderDetails: $subscriptionDetailsInput
    ) {
      appointmentDateTime
      appointmentId
      displayId
      doctorName
      doctorId
      isError
      error
    }
  }
`;

export const GET_HOSPITALS_AND_CLINICS = gql`
  query hospitalDetailUrlsList($pageSize: Int!, $pageNumber: Int!) {
    hospitalDetailUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      hospitalDetailUrls {
        urlName
        url
      }
      urlsCount
    }
  }
`;

export const GET_HOSPITALS_LOCATION = gql`
  query hospitalLocationUrlsList($pageSize: Int!, $pageNumber: Int!) {
    hospitalLocationUrlsList(pageNumber: $pageNumber, pageSize: $pageSize) {
      hospitalLocationUrls {
        urlName
        url
      }
      urlsCount
    }
  }
`;

export const GET_DIAGNOSTIC_PINCODE_SERVICEABILITIES = gql`
  query getPincodeServiceability($pincode: Int!) {
    getPincodeServiceability(pincode: $pincode) {
      cityID
      cityName
      stateID
      stateName
      areaSelectionEnabled
    }
  }
`;

export const GET_ONE_APOLLO_USER_TRANSACTIONS = gql`
  query getOneApolloUserTransactions {
    getOneApolloUserTransactions {
      earnedHC
      transactionDate
      grossAmount
      netAmount
      transactionDate
      businessUnit
      redeemedHC
    }
  }
`;

export const GET_DIAGNOSTIC_CITYID_BY_CITY = gql`
  query getDiagnosticCityIdByCity($city: String!) {
    getDiagnosticCityIdByCity(city: $city) {
      cityByCityIds {
        city
        cityId
      }
    }
  }
`;

export const GET_PATIENT_PAST_LOCATIONS = gql`
  query getPatientPastLocations($patientId: String, $patientMobile: String) {
    getPatientPastLocations(
      patientId: $patientId
      patientMobile: $patientMobile
    ) {
      pastLocations {
        city
        pincode
      }
      popularCities {
        city
        pincode
      }
    }
  }
`;

export const GET_PAST_CONSULTS_PRESCRIPTIONS_BY_MOBILE = gql`
  query getLinkedProfilesPastConsultsAndPrescriptionsByMobile(
    $consultsAndOrdersByMobileInput: PatientConsultsAndOrdersByMobileInput
  ) {
    getLinkedProfilesPastConsultsAndPrescriptionsByMobile(
      consultsAndOrdersByMobileInput: $consultsAndOrdersByMobileInput
    ) {
      consults {
        id
        patientId
        doctorId
        appointmentDateTime
        appointmentType
        appointmentState
        hospitalId
        isFollowUp
        followUpParentId
        followUpTo
        displayId
        bookingDate
        caseSheet {
          prismFileId
          notes
          blobName
          consultType
          diagnosis {
            name
          }
          diagnosticPrescription {
            itemname
          }
          doctorId
          doctorType
          followUp
          followUpAfterInDays
          followUpDate
          id

          medicinePrescription {
            id
            externalId
            medicineName
            medicineDosage
            medicineToBeTaken
            medicineInstructions
            medicineTimings
            medicineUnit
            medicineConsumptionDurationInDays
            medicineConsumptionDuration
            medicineFormTypes
            medicineFrequency
            medicineConsumptionDurationUnit
            routeOfAdministration
            medicineCustomDosage
          }
          symptoms {
            symptom
            since
            howOften
            severity
          }
        }
        displayId
        status
        doctorInfo {
          id
          salutation
          firstName
          lastName
          displayName
          fullName
          experience
          city
          onlineConsultationFees
          physicalConsultationFees
          photoUrl
          qualification
          specialty {
            id
            name
            userFriendlyNomenclature
            image
          }
          doctorHospital {
            facility {
              id
              name
            }
          }
        }
      }
    }
  }
`;

export const GET_PRIMARY_PATIENTS_BY_MOBILE_NUMBER = gql`
  query GetPrimaryPatientsByMobileNumber($mobileNumber: String) {
    getPrimaryPatientsByMobileNumber(mobileNumber: $mobileNumber) {
      patients {
        id
        externalAuthId
        mobileNumber
        firstName
        lastName
        relation
        gender
        uhid
        dateOfBirth
        emailAddress
        photoUrl
        referralCode
        partnerId
        isConsulted
        createdDate
        primaryUhid
        patientMedicalHistory {
          height
          weight
          bp
          dietAllergies
          bloodGroup
        }
      }
    }
  }
`;
